/*************************************************************************
****  PROYECTO   : Landing - Alfin Contacto
****  OBJETO     : App.js
****  DESCRIPCIÓN: Componente raíz de la aplicación - Rutas + ReCaptcha
****               Provider + UtmProvider
****
**** ------------------------------------------------------------------------------------------------
**** | PROGRAMADOR       | FECHA       | TIPO CAMBIO   | DESCRIPCIÓN                                |
**** ------------------------------------------------------------------------------------------------
**** | Reynaldo Yovera   | --/--/----  | CREACIÓN      | Creación inicial                           |
**** | Miguel Sanchez    | 06/04/2026  | MODIFICACIÓN  | Se agrega RedirectWithQuery para preservar |
**** |                   |             |               | parámetros UTM en los redirects de rutas   |
**** ------------------------------------------------------------------------------------------------
*******************************************************************************/
import './App.css';
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ClienteLanding from './pages/Clientes/ClienteLanding';
import AsesorLanding from './pages/Asesores/AsesoresLanding';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React, { Suspense, lazy, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home/home';
import { UtmProvider } from "./context/UtmContext";


function getRouterBasename(publicUrl) {
  if (!publicUrl) return "/";

  try {
    const { pathname } = new URL(publicUrl, window.location.origin);
    return pathname.replace(/\/+$/, "") || "/";
  } catch {
    return publicUrl.replace(/\/+$/, "") || "/";
  }
}

function RedirectWithQuery({ to }) {
  const location = useLocation();

  return <Navigate to={`${to}${location.search}`} replace />;
}

function App() {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [mostrarModal, setMostrarModal] = useState(false);
  const routerBasename = getRouterBasename(process.env.PUBLIC_URL);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
     <BrowserRouter basename={routerBasename}>
       <UtmProvider>
          <Suspense fallback={<div>Cargando...</div>}>
            <Routes> 
              <Route path="/home" element={<Home />}>
                <Route index element={<RedirectWithQuery to="clientes" />} />
                <Route path="clientes" element={<ClienteLanding />} />
                <Route path="asesores" element={<AsesorLanding />} />
              </Route>
              <Route path="/" element={<RedirectWithQuery to="/home/clientes" />} />
              <Route path="*" element={<div>404 - Página no encontrada</div>} />
            </Routes>
          </Suspense>
       </UtmProvider>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}
export default App;
